export default __webpack_public_path__ + "static/Entenda0012-7ab54136f73dd33226ef496ee2e61e16.jpg";